import { type Frequency, type Interval } from 'investments/common/entities'

import { httpClientBanking } from '~/domains/banking/shared/infra/http-client-banking'
import { useQueryRequest } from '~/ui/hooks/utils'

export type RecurrenceSettings = {
  [key in Frequency]: {
    description: string
    interval: {
      name: Interval
      description: string
    }[]
  }
}

type GetRecurrenceSettingsApiResponse = {
  recurrenceSettings: {
    frequency: {
      description: string
      name: Frequency
    }
    interval: {
      name: Interval
      description: string
    }[]
  }[]
}

async function fetchRecurrenceSettings() {
  const { data } = await httpClientBanking<GetRecurrenceSettingsApiResponse>({
    url: `/investments/recurrence_settings`
  })
  return data.recurrenceSettings ?? []
}

export function useFetchRecurrenceSettings() {
  const {
    data = [],
    isLoading: isRecurrenceSettingsLoading,
    isError: isRecurrenceSettingsError,
    isSuccess: isRecurrenceSettingsSuccess
  } = useQueryRequest<Awaited<ReturnType<typeof fetchRecurrenceSettings>>, unknown, true>(
    ['useFetchRecurrenceSettings'],
    fetchRecurrenceSettings,
    { suspense: true }
  )
  const recurrenceSettings = data.reduce((result, item) => {
    result[item.frequency.name] = {
      description: item.frequency.description,
      interval: item.interval
    }
    return result
  }, {} as RecurrenceSettings)
  return { recurrenceSettings, isRecurrenceSettingsLoading, isRecurrenceSettingsError, isRecurrenceSettingsSuccess }
}
